import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { borderRadius, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { BorderRadiusSkeleton } from 'modules/predictiveGoals/components/Styled';

const SkeletonComponentsContainer = styled(FlexSpacer)`
  padding: ${pxToRem(64)} 0 ${pxToRem(112)} 0 !important;
`;

const SkeletonSection = styled(FlexSpacer)`
  background: ${colors.backgroundTertiary};
  border-radius: ${borderRadius.lg};
`;

const SkeletonCard = styled.div`
  background: ${colors.backgroundSecondary};
  border-radius: ${borderRadius.lg};
  height: ${pxToRem(124)};
  width: ${pxToRem(374)};
`;

export const IndexSkeletonId = 'index-skeleton-loader';

export const PredictiveGoalsIndexSkeleton = () => {
  return (
    <SkeletonComponentsContainer
      data-test={IndexSkeletonId}
      flexDirection="column"
      gap="double"
      width="100%"
    >
      <SkeletonSection padding="cardPadding" width="100%" gap="base">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </SkeletonSection>
      <BorderRadiusSkeleton height={344} />
    </SkeletonComponentsContainer>
  );
};
